module.exports = __webpack_public_path__ + "static/media/zoo_logo.f6080def.svg";